module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "the_real_cost.31ddb5a3.png";